
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/home/runner/work/beesphone-mono/beesphone-mono/apps/web/nuxt/beesphone-web/sentry.client.config.ts")
            }
          });